import { type GetterTree } from 'vuex';

import { DEFAULT_KEY } from './constants';
import { type IAmendmentState } from './types';

export const GET_AGGREGATION_BY_STATUS = 'getAggregationByStatus';

export const getters: GetterTree<IAmendmentState, unknown> = {
    [GET_AGGREGATION_BY_STATUS]: (_state) => {
        return (status: string, key = DEFAULT_KEY): number => {
            return _state.aggregationByStatus[key.toString()]?.byStatus[status] ?? 0;
        };
    }
};
